import { render, staticRenderFns } from "./users-management-page.vue?vue&type=template&id=00d182a0&scoped=true"
import script from "./users-management-page.vue?vue&type=script&lang=js"
export * from "./users-management-page.vue?vue&type=script&lang=js"
import style0 from "./users-management-page.vue?vue&type=style&index=0&id=00d182a0&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "00d182a0",
  null
  
)

export default component.exports